module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"next_galaxy":"次の銀河","screenshot":"スクリーンショット","log":"航海記録","passport":"パスポート","settings":"設定","souvenirs":"おみやげ"},"en":{"next_galaxy":"Next Galaxy","screenshot":"Screenshot","log":"Voyage Log","passport":"Passport","settings":"Settings","souvenirs":"Souvenirs"}}')
  delete Component.options._Ctor
}
